import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Form, FormGroup, Label } from 'reactstrap';
import { Button, InputField } from 'src/components';
import { setFromErrors } from 'src/helpers';
import {
  useCreateLogbookEntrySetupDetailGroupMutation,
  useGetFcpsCourseListsForLogbookEntryMutation,
  useLazyGetFormByLogbookTypeAndSubjectQuery,
} from 'src/rtk/features/setup/logBookEntrySetupDetails/logBookEntrySetupDetailsApi';
import { useGetSubjectInfosQuery } from 'src/rtk/features/setup/subjectInfo/subjectInfoApi';
import AddLogbookEntryDetailsFields from './AddLogbookEntryDetailsFields';
import loader from '../../../assets/images/loader.gif';

const initialValues: LogbookEntryDetailsGroup = {
  id: '',
  title: '',
  subject_id: '',
  main_training_id: '',
  course_type: '',
  from: '',
  case_type_id: '',
  skill_type_id: '',
  status: false,
  creator_organization_id: '',
  updater_organization_id: '',
  created_by: '',
  updated_by: '',
  deleted_by: '',
  created_at: '',
  updated_at: '',
  deleted_at: '',
};

interface QueryParams {
  id?: number;
  course_type?: string;
  subject_id?: string;
  main_training?: string;
}

export const AddLogbookEntryDetails = () => {
  const [createLogbookEntryDetailGroup, { data, isSuccess, isLoading, isError, error }] =
    useCreateLogbookEntrySetupDetailGroupMutation();

  const err: CustomError = error as CustomError;

  const [subject, setSubject] = useState<SubjectInfo>({} as SubjectInfo);

  const [mainTrainings, setMainTrainings] = useState<FcpsCourseList[]>([]);

  const [mainTraining, setMainTraining] = useState<FcpsCourseList>(
    {} as FcpsCourseList,
  );

  const [coreAdvanceOptions, setCoreAdvanceOptions] = useState<SelectOption[]>([]);
  const [coreAdvance, setCoreAdvance] = useState<string>('');

  const [forms, setForms] = useState<LogbookEntrySetupMaster[]>([]);

  const [form, setForm] = useState<LogbookEntrySetupMaster>(
    {} as LogbookEntrySetupMaster,
  );

  const [logbookEntrySetupMasters, setLogbookEntrySetupMasters] = useState<LogbookEntrySetupMaster[][]>([]);
  const [logbookEntrySetupMaster, setLogbookEntrySetupMaster] = useState<LogbookEntrySetupMaster[]>([]);

  // const [systemType, setSystemType] = useState<LogbookEntrySetupMaster>(
  //   {} as LogbookEntrySetupMaster,
  // );

  // const [systemTypes, setSystemTypes] = useState<LogbookEntrySetupMaster[]>([]);

  // const [caseType, setCaseType] = useState<LogbookEntrySetupMaster>(
  //   {} as LogbookEntrySetupMaster,
  // );

  // const [caseTypes, setCaseTypes] = useState<LogbookEntrySetupMaster[]>([]);

  // const [skillType, setSkillType] = useState<LogbookEntrySetupMaster>(
  //   {} as LogbookEntrySetupMaster,
  // );

  const [queryParams, setQueryParams] = useState<QueryParams>(
    {} as QueryParams,
  );

  // const [skillTypes, setSkillTypes] = useState<LogbookEntrySetupMaster[]>([]);

  const [logbookEntrySetupMasterId, setLogbookEntrySetupMasterId] =
    useState<string>('');

  const [logbookGroup, setLogbookGroup] = useState<LogbookEntryDetailsGroup>(
    {} as LogbookEntryDetailsGroup,
  );

  const [submitted, setSubmitted] = useState<boolean>(false);

  const { data: getSubjectInfolist } = useGetSubjectInfosQuery();
  const subjects = getSubjectInfolist?.data;

  const [
    createFcpsCourse,
    {
      data: fcpsCourseListData,
      isSuccess: isFcpsCourseListSuccess,
      isError: isFcpsCourseListError,
      isLoading: isFcpsCourseListLoading,
      error: fcpsCourseListError,
    },
  ] = useGetFcpsCourseListsForLogbookEntryMutation();

  const [getForms, { data: formSetups, isSuccess: isFormSetupsSuccess, isLoading: isFormSetupsLoading, isFetching: isFormSetupsFetching, }] =
    useLazyGetFormByLogbookTypeAndSubjectQuery();

  // const { data: logbookEntrySetupDetailsData } = useGetLogbookEntrySetupDetailsQuery();
  // const logbookEntrySetupDetails = logbookEntrySetupDetailsData?.data?.filter((l: LogbookEntryDetails) => l.logbook_entry_setup_master_id === logbookEntrySetupMasterId) || [];

  let subjectOptions: SelectOption[] =
    subjects?.map((subject) => ({
      value: subject.id!,
      label: subject.subject_name,
    })) || [];

  let mainTrainingOptions: SelectOption[] =
    mainTrainings?.map((mainTraining) => ({
      value: mainTraining.id!,
      label: mainTraining.name!,
    })) || [];

  let formOptions: SelectOption[] =
    forms?.map((e: LogbookEntrySetupMaster) => {
      return {
        label: e.particulars!,
        value: e.id!,
      };
    }) ?? [];

  // let systemTypeOptions: SelectOption[] =
  //   systemTypes?.map((e: LogbookEntrySetupMaster) => {
  //     return {
  //       label: e.particulars!,
  //       value: e.id!,
  //     };
  //   }) ?? [];

  // let caseTypeOptions: SelectOption[] =
  //   caseTypes?.map((e: LogbookEntrySetupMaster) => {
  //     return {
  //       label: e.particulars!,
  //       value: e.id!,
  //     };
  //   }) ?? [];

  // let skillTypeOptions: SelectOption[] =
  //   skillTypes?.map((e: LogbookEntrySetupMaster) => {
  //     return {
  //       label: e.particulars!,
  //       value: e.id!,
  //     };
  //   }) ?? [];

  // let logbookEntrySetupDetailOptions: SelectOption[] = [
  //   ...logbookEntrySetupDetails?.map((l: LogbookEntryDetails) => ({
  //     label: l.column_name!,
  //     value: l.id!,
  //   })),
  // ];

  const formik = useFormik({
    initialValues,
    // validationSchema: Yup.object({
    //   column_name: Yup.string().matches(
    //     /^[^.]*$/,
    //     'Please provide the name without a dot(.)',
    //   ),
    //   // logbook_entry_setup_master_id: Yup.string().required('Please select the logbook entry setup master'),
    // }),

    onSubmit: (values) => {
      values.subject_id = subject?.id!;
      values.main_training_id = mainTraining?.id!;
      values.course_type = coreAdvance;
      values.from = form?.id!;
      values.case_type_id = logbookEntrySetupMaster[0]?.id!;
      if (logbookEntrySetupMaster.length > 0) {
        values.skill_type_id = logbookEntrySetupMaster[logbookEntrySetupMaster.length - 1]?.id!;
      }
      values.title =
        subject?.subject_name +
        ' -> ' +
        mainTraining?.name +
        ' -> ' +
        coreAdvance +
        ' -> ' +
        form?.particulars;

      logbookEntrySetupMaster.forEach((entrySetupMaster: LogbookEntrySetupMaster) => {
        values.title = values.title + ' -> ' + entrySetupMaster.particulars;
      });

      createLogbookEntryDetailGroup({
        ...values,
      });

      console.log(values);
    },
  });

  const handleFormReset = () => {
    setSubject({ id: '' } as SubjectInfo);
    setMainTraining({ id: '' } as FcpsCourseList);
    setCoreAdvance('');
    setForm({ id: '' } as LogbookEntrySetupMaster);
    setForms([]);
    setMainTrainings([]);
    setCoreAdvanceOptions([]);
    // setSystemType({ id: '' } as LogbookEntrySetupMaster);
    // setCaseType({ id: '' } as LogbookEntrySetupMaster);
    // setSkillType({ id: '' } as LogbookEntrySetupMaster);
    setQueryParams({} as QueryParams);
    setLogbookEntrySetupMasterId('');
    setLogbookEntrySetupMasters([]);
    setLogbookEntrySetupMaster([]);
  };

  const handleFormResetAfterSubmit = () => {
    setSubject({ id: '' } as SubjectInfo);
    setMainTraining({ id: '' } as FcpsCourseList);
    setCoreAdvance('');
    setForm({ id: '' } as LogbookEntrySetupMaster);
    setForms([]);
    setMainTrainings([]);
    setCoreAdvanceOptions([]);
    // setSystemType({ id: '' } as LogbookEntrySetupMaster);
    // setCaseType({ id: '' } as LogbookEntrySetupMaster);
    // setSkillType({ id: '' } as LogbookEntrySetupMaster);
    setQueryParams({} as QueryParams);
    setSubmitted(true);
    setLogbookEntrySetupMasters([]);
    setLogbookEntrySetupMaster([]);
  };

  useEffect(() => {
    if (isSuccess) {
      handleFormResetAfterSubmit();
      setLogbookGroup(data?.data!);
      toast.success('Group created successfully');
    }
    if (isError) {
      toast.error(err?.message || 'Something went wrong');
      setFromErrors(err.data, formik.setErrors);
    }
  }, [isSuccess, isError]);

  const handleSubjectSelect = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    const subject = subjects?.find((subject) => subject.id === value);
    setSubject(subject!);
    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.subject_id = subject?.id;
    newQueryParams.main_training = '';
    newQueryParams.course_type = '';
    setQueryParams(newQueryParams);
    setCoreAdvanceOptions([]);
    setForms([]);
    setLogbookEntrySetupMaster([]);
    setLogbookEntrySetupMasters([]);
    setLogbookEntrySetupMasterId('');
    setForm({ id: '' } as LogbookEntrySetupMaster);
    setMainTraining({ id: '' } as FcpsCourseList);
    setCoreAdvance('');
    if (value === '') {
      setMainTrainings([]);
    }
  };

  const handleMainTrainingOption = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    const mainTraining = mainTrainings?.find(
      (mainTraining) => mainTraining.id === value,
    );
    setMainTraining(mainTraining!);
    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.main_training = mainTraining?.id;
    newQueryParams.course_type = '';
    setQueryParams(newQueryParams);
    setForms([]);
    setLogbookEntrySetupMaster([]);
    setLogbookEntrySetupMasters([]);
    setLogbookEntrySetupMasterId('');
    setCoreAdvance('');
    setForm({ id: '' } as LogbookEntrySetupMaster);
    if (value === '') {
      setCoreAdvanceOptions([]);
    } else {
      setCoreAdvanceOptions([
        { label: 'Core', value: 'core' },
        { label: 'Specialty', value: 'adv' },
      ]);
    }
  };

  const handleCoreAdvance = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    setCoreAdvance(value!);
    const newQueryParams: QueryParams = { ...queryParams };
    newQueryParams.course_type = value;
    setQueryParams(newQueryParams);
    setLogbookEntrySetupMaster([]);
    setLogbookEntrySetupMasters([]);
    setLogbookEntrySetupMasterId('');
    setForm({ id: '' } as LogbookEntrySetupMaster);
    if (value === '') {
      setForms([]);
    } else {
      setForms(formSetups?.data!);
    }
  };

  const handleFormSelect = (e: any) => {
    const { options, selectedIndex, value } = e.target;
    const form = forms.find((form) => form.id === value);
    setForm(form!);
    setLogbookEntrySetupMasterId('');
    const newLogbookEntrySetupMasters: LogbookEntrySetupMaster[][] = [];
    const newLogbookEntrySetupMaster: LogbookEntrySetupMaster[] = [];
    if (form) {
      newLogbookEntrySetupMasters[0] = form?.entry_setup_master!;
      newLogbookEntrySetupMaster[0] = form!;
      setLogbookEntrySetupMasters(newLogbookEntrySetupMasters);
      setLogbookEntrySetupMaster(newLogbookEntrySetupMaster);
    } else {
      setLogbookEntrySetupMasters([]);
      setLogbookEntrySetupMaster([]);
    }
  };

  // const handleSystemTypeSelect = (e: any) => {
  //   const { options, selectedIndex, value } = e.target;
  //   const systemType: any = systemTypes?.find((c: any) => c.id === value);
  //   const systemTypeChildData: any = systemTypes?.find(
  //     (c: any) => c.id === value,
  //   )?.entry_setup_master;
  //   setSystemType(systemType);
  //   if (value === '') {
  //     setLogbookEntrySetupMasterId('');
  //   } else {
  //     if (systemTypeChildData?.length === 0) {
  //       setLogbookEntrySetupMasterId(systemType.id || '');
  //       setSubmitted(false);
  //     }
  //   }
  // };

  // const handleCaseTypeSelect = (e: any) => {
  //   const { options, selectedIndex, value } = e.target;
  //   const caseType: any = caseTypes?.find((c: any) => c.id === value);
  //   const caseTypeChildData: any = caseTypes?.find(
  //     (c: any) => c.id === value,
  //   )?.entry_setup_master;
  //   setCaseType(caseType);
  //   if (value === '') {
  //     setLogbookEntrySetupMasterId('');
  //   } else {
  //     if (caseTypeChildData?.length === 0) {
  //       setLogbookEntrySetupMasterId(caseType.id || '');
  //       setSubmitted(false);
  //     }
  //   }
  // };

  // const handleSkillTypeSelect = (e: any) => {
  //   const { options, selectedIndex, value } = e.target;
  //   const skillType: any = skillTypes?.find((s: any) => s.id === value);
  //   setSkillType(skillType);
  //   if (value === '') {
  //     setLogbookEntrySetupMasterId('');
  //   } else {
  //     setLogbookEntrySetupMasterId(skillType.id || '');
  //     setSubmitted(false);
  //   }
  // };

  const handleEntrySetupMasterChilds = (e: any, index: number) => {
    const { options, selectedIndex, value } = e.target;
    const newLogbookEntrySetupMasters: LogbookEntrySetupMaster[][] = [...logbookEntrySetupMasters];
    const newLogbookEntrySetupMaster: LogbookEntrySetupMaster[] = [...logbookEntrySetupMaster];

    if (value !== '') {
      const skillType: LogbookEntrySetupMaster = logbookEntrySetupMasters[index]?.find((s: any) => s.id === value)!;

      if (skillType?.entry_setup_master?.length! > 0 && !newLogbookEntrySetupMasters[index + 1]) {
        newLogbookEntrySetupMasters.push(skillType?.entry_setup_master!);
        newLogbookEntrySetupMaster[index] = skillType;
        newLogbookEntrySetupMaster.forEach((entrySetupMaster: LogbookEntrySetupMaster, i: number) => {
          if (i > index) {
            newLogbookEntrySetupMaster[i] = { id: '', setup_logbook_master_id: '', status: false };
          }
        });
        setLogbookEntrySetupMasterId('');
      } else if (skillType?.entry_setup_master?.length! > 0 && newLogbookEntrySetupMasters[index + 1]) {
        newLogbookEntrySetupMasters[index + 1] = skillType?.entry_setup_master!;
        newLogbookEntrySetupMaster[index] = skillType;
        newLogbookEntrySetupMaster.forEach((entrySetupMaster: LogbookEntrySetupMaster, i: number) => {
          if (i > index) {
            newLogbookEntrySetupMaster[i] = { id: '', setup_logbook_master_id: '', status: false };
          }
        });
        setLogbookEntrySetupMasterId('');
      } else if (skillType?.entry_setup_master?.length! === 0) {
        newLogbookEntrySetupMaster[index] = skillType;
        if (newLogbookEntrySetupMaster.length > index) {
          newLogbookEntrySetupMaster.splice(index + 1, newLogbookEntrySetupMaster.length - index - 1);
        }
        if (newLogbookEntrySetupMasters.length > index) {
          newLogbookEntrySetupMasters.splice(index + 1, newLogbookEntrySetupMasters.length - index - 1);
        }
        setLogbookEntrySetupMasterId(skillType?.id!);
      }

      newLogbookEntrySetupMaster[index] = skillType;
    } else {
      newLogbookEntrySetupMasters.splice(index + 1, newLogbookEntrySetupMasters.length - index - 1);
      newLogbookEntrySetupMaster[index] = { id: '', setup_logbook_master_id: '', status: false };
      setLogbookEntrySetupMasterId('');
    }

    setLogbookEntrySetupMasters(newLogbookEntrySetupMasters);
    setLogbookEntrySetupMaster(newLogbookEntrySetupMaster);
  };

  useEffect(() => {
    if (isFcpsCourseListSuccess && fcpsCourseListData?.success) {
      const mainTrainings: FcpsCourseList[] = fcpsCourseListData.data;
      setMainTrainings(mainTrainings);
    } else {
      setMainTrainings([]);
    }
  }, [isFcpsCourseListSuccess, fcpsCourseListData?.success]);

  useEffect(() => {
    createFcpsCourse(subject?.id!);
  }, [subject]);

  useEffect(() => {
    if (
      queryParams.subject_id &&
      queryParams.main_training &&
      queryParams.course_type
    ) {
      queryParams.id = 2;
      getForms(queryParams);
    }
  }, [queryParams]);

  useEffect(() => {
    if (formSetups && isFormSetupsSuccess) {
      setForms(formSetups?.data);
    }
  }, [formSetups, isFormSetupsSuccess]);

  // useEffect(() => {
  //   setSystemTypes(form?.entry_setup_master! ?? []);
  // }, [form]);

  // useEffect(() => {
  //   setCaseTypes(systemType?.entry_setup_master! ?? []);
  // }, [systemType]);

  // useEffect(() => {
  //   setSkillTypes(caseType?.entry_setup_master! ?? []);
  // }, [caseType]);

  return (
    <>
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <hr />
      <Form
        className="custom-form"
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
        }}
        onReset={(e) => {
          e.preventDefault();
          handleFormReset();
        }}
      >
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">Subject</Label>
              <InputField
                type="select"
                name="subject"
                value={subject?.id}
                placeholder=""
                options={subjectOptions}
                onChange={(e) => {
                  handleSubjectSelect(e);
                }}
              />
            </FormGroup>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">Main Training</Label>
              <InputField
                type="select"
                name="mainTraining"
                value={mainTraining?.id}
                placeholder=""
                options={mainTrainingOptions}
                onChange={(e) => {
                  handleMainTrainingOption(e);
                }}
              />
            </FormGroup>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">Core/Specialty</Label>
              <InputField
                type="select"
                name="coreAdvance"
                placeholder=""
                value={coreAdvance}
                options={coreAdvanceOptions}
                onChange={(e) => {
                  handleCoreAdvance(e);
                }}
              />
            </FormGroup>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">Form</Label>
              <InputField
                type="select"
                name="form"
                placeholder=""
                value={form?.id}
                options={formOptions}
                onChange={(e) => {
                  handleFormSelect(e);
                }}
              />
            </FormGroup>
          </div>

          {/* <div className="col-lg-4 col-md-6 col-sm-12">
            <FormGroup className="mb-3">
              <Label className="form-label">System Type</Label>
              <InputField
                type="select"
                name="systemType"
                value={systemType?.id}
                placeholder=""
                options={systemTypeOptions}
                onChange={(e) => {
                  handleSystemTypeSelect(e);
                }}
              />
            </FormGroup>
          </div>

          {caseTypes?.length > 0 ? (
            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-3">
                <Label className="form-label">Topic Type</Label>
                <InputField
                  type="select"
                  name="caseType"
                  value={caseType?.id}
                  placeholder=""
                  options={caseTypeOptions}
                  onChange={(e) => {
                    handleCaseTypeSelect(e);
                  }}
                />
              </FormGroup>
            </div>
          ) : null}

          {skillTypes?.length > 0 ? (
            <div className="col-lg-4 col-md-6 col-sm-12">
              <FormGroup className="mb-3">
                <Label className="form-label">Skill Type</Label>
                <InputField
                  type="select"
                  name="skillType"
                  value={skillType?.id}
                  placeholder=""
                  options={skillTypeOptions}
                  onChange={(e) => {
                    handleSkillTypeSelect(e);
                  }}
                />
              </FormGroup>
            </div>
          ) : null} */}

          {logbookEntrySetupMasters?.map((entrySetupMaster: LogbookEntrySetupMaster[], index: number) => {
            return (
              <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                <FormGroup className="mb-3">
                  <Label className="form-label">{index === 0 ? 'System Type' : index === 1 ? 'Topic Type' : `Skill Type ${index - 1}`}</Label>
                  <InputField
                    type="select"
                    name={`skillType${index + 1}`}
                    value={logbookEntrySetupMaster[index]?.id}
                    placeholder=""
                    options={
                      entrySetupMaster?.map((e: LogbookEntrySetupMaster) => {
                        return {
                          label: e.particulars!,
                          value: e.id!,
                        };
                      }) ?? []
                    }
                    onChange={(e) => {
                      handleEntrySetupMasterChilds(e, index);
                    }}
                  />
                </FormGroup>
              </div>
            );
          })}

          <div className="col-sm-4 mt-4">
            {!submitted ? (
              <>
                {logbookEntrySetupMasterId === '' ? (
                  <Button
                    type="submit"
                    text="Add Group"
                    className="me-2"
                    disabled
                  />
                ) : (
                  <Button type="submit" text="Add Group" className="me-2" />
                )}
                <Button type="reset" text="Reset" color="warning" />
              </>
            ) : (
              <>
                <Button
                  type="submit"
                  text="Add Group"
                  className="me-2"
                  disabled
                />
                <Button type="reset" text="Reset" color="warning" disabled />
              </>
            )}
          </div>
        </div>
      </Form>

      {logbookEntrySetupMasterId !== '' && submitted && logbookGroup ? (
        <>
          <AddLogbookEntryDetailsFields
            key={logbookEntrySetupMasterId}
            logbookEntrySetupMasterId={logbookEntrySetupMasterId}
            logbookGroup={logbookGroup}
            submitStatus={submitted}
            readOnly={false}
          />
        </>
      ) : (
        <AddLogbookEntryDetailsFields
          key={logbookEntrySetupMasterId}
          logbookEntrySetupMasterId={logbookEntrySetupMasterId}
          logbookGroup={logbookGroup}
          submitStatus={submitted}
          readOnly={true}
        />
      )}
    </>
  );
};
